<template>
    <div>
        <v-app id="inspire">
            <v-navigation-drawer v-model="drawer" app mini-variant expand-on-hover>
                <NavDrawerList :groups="navList"/>
            </v-navigation-drawer>
            <v-app-bar app dense elevation="1" color="white">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title>Purchasing and Ordering</v-toolbar-title>
                <v-spacer></v-spacer>
                <ToolbarMenuRight />
            </v-app-bar>
            <v-main>
                <router-view></router-view>
            </v-main>
            <QuickNavDialog v-model="quickNav"/>
            <v-snackbar :value="snackbar.display" @input="hideSnackbar" :color="snackbar.color" bottom right>{{snackbar.text}}</v-snackbar>
        </v-app>
    </div>
</template>

<script>
import permissions from './../data/permissions'
import ToolbarMenuRight from "@/components/common/ToolbarMenuRight";
import NavDrawerList from './../components/common/NavDrawerList';
import QuickNavDialog from './../components/common/QuickNavDialog';
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
        ToolbarMenuRight,
        NavDrawerList,
        QuickNavDialog
    },
    props: {

    },
    data() {
        return {
            quickNav: false,
            drawer: null,
            perm: permissions,
        }
    },
    computed: {
        ...mapGetters({
            snackbar: "ui/snackbar/snackbar",
            hasPermission: "authentication/hasPermission"
        }),
        navList() {
            return [
                {
                    text: "Pre-Purchase Activities",
                    icon: "mdi-folder",
                    items: [
                        {
                            text: "Suppliers",
                            icon: "mdi-format-list-checks",
                            authorization: this.perm.supplier.index,
                            to: "/purchase/suppliers"
                        },
                        {
                            text: "Requisitions",
                            icon: "mdi-file-document-edit-outline",
                            authorization: this.perm.purchase_requisition.index,
                            to: "/purchase/requisitions"
                        },
                    ]
                },
                {
                    text: "Ordering",
                    icon: "mdi-folder",
                    items: [
                        {
                            text: "Price Checker",
                            icon: "mdi-percent-circle-outline",
                            authorization: this.perm.purchase_order.create,
                            to: "/purchase/price-checker"
                        },
                        {
                            text: "Purchase Orders",
                            icon: "mdi-format-list-checks",
                            authorization: this.perm.purchase_order.index,
                            to: "/purchase/orders"
                        },
                        {
                            text: "Goods Receipts",
                            icon: "mdi-archive",
                            authorization: this.perm.po_good_receipt.index,
                            to: "/purchase/receipts"
                        },
                        {
                            text: "General Receipts",
                            icon: "mdi-circle-box",
                            authorization: this.perm.general_receipt.index,
                            to: "/purchase/general-receipts"
                        },
                        {
                            text: "Goods Return Vouchers",
                            icon: "mdi-export",
                            authorization: this.perm.good_return.index,
                            to: "/purchase/returns"
                        },
                        {
                            text: "Landed Costs",
                            icon: "mdi-truck-cargo-container",
                            authorization: this.perm.landed_cost.index,
                            to: "/purchase/landed-costs"
                        }
                    ]
                },
                {
                    text: 'Accounts Payable',
                    icon: 'mdi-folder',
                    items: [
                        {
                            text: "Credit Notes",
                            icon: "mdi-note-minus",
                            authorization: this.perm.credit_note.index,
                            to: "/purchase/credit-notes"
                        },
                        {
                            text: "Debit Notes",
                            icon: "mdi-note-plus",
                            authorization: this.perm.debit_note.index,
                            to: "/purchase/debit-notes"
                        },
                        {
                            text: "Invoices",
                            icon: "mdi-receipt",
                            authorization: this.perm.invoice.index,
                            to: "/purchase/invoices"
                        },
                        {
                            text: "Payments",
                            icon: "mdi-cash",
                            authorization: this.perm.payment.index,
                            to: "/purchase/payments"
                        }
                    ]
                },
                {
                    text: 'Reports',
                    icon: 'mdi-folder',
                    items: [
                        {
                            text: "Dashboard",
                            icon: "mdi-google-analytics",
                            authorization: this.perm.report.purchase_dashboard,
                            to: "/purchase/dashboard"
                        },
                        {
                            text: "Supplier Statement",
                            icon: "mdi-chart-bar",
                            authorization: this.perm.report.supplier_account_statement,
                            to: "/purchase/supplier-account-statement"
                        },
                        {
                            text: "Accounts Summary",
                            icon: "mdi-chart-bar",
                            authorization: this.perm.report.supplier_account_summary,
                            to: "/purchase/supplier-account-summary"
                        },
                        {
                            text: "Order FullFillment",
                            icon: "mdi-chart-bar",
                            authorization: this.perm.report.purchase_order_fulfillment,
                            to: "/purchase/orders-fulfillment"
                        },
                        {
                            text: "Orders Completed",
                            icon: "mdi-chart-bar",
                            authorization: this.perm.report.purchase_order_fulfillment,
                            to: "/purchase/orders-completion"
                        },
                        {
                            text: "Purchase Summary",
                            icon: "mdi-chart-pie",
                            authorization: this.perm.report.purchase_summary,
                            to: "/purchase/purchase-summary"
                        }
                    ]
                },
                {
                    text: "Setting",
                    icon: "mdi-folder",
                    items: [
                        {
                            text: "Supplier Groups",
                            icon: "mdi-nature-people",
                            authorization: this.perm.supplier_group.index,
                            to: "/purchase/supplier-groups"
                        },
                        {
                            text: "Payment Modes",
                            icon: "mdi-cash",
                            authorization: this.perm.payment_account.create,
                            to: "/purchase/payment-modes"
                        },
                        {
                            text: "Landed Cost Components",
                            icon: "mdi-truck-cargo-container",
                            authorization: this.perm.landed_cost_component.index,
                            to: "/purchase/landed-cost-components"
                        }
                    ]
                }
            ]
        }
    },
    methods: {
        ...mapActions({
            hideSnackbar: "ui/snackbar/hide"
        }),
        bindShortcuts(e) {
            if(e.keyCode === 68 && e.ctrlKey === true) {
                e.preventDefault();
                this.quickNav = true;
            }
        },
    },
    created() {
        document.addEventListener("keydown", this.bindShortcuts);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.bindShortcuts);
    }
};
</script>
